import type { SVGProps } from 'react'

import { CONNECT_BRAND } from '@/lib/connect/brand'
import { cn } from '@/lib/utils'

/** The background behind the mark; theme follows the site's CSS dark mode. */
type ConnectLogoTone = 'dark' | 'light' | 'theme'

export function ConnectMark({ tone, ...props }: SVGProps<SVGSVGElement> & {
  tone: ConnectLogoTone
}) {
  const tones = tone === 'theme' ? ['light', 'dark'] as const : [tone]

  return (
    <svg viewBox="0 0 324 324" fill="none" aria-hidden="true" {...props}>
      {tones.map(background => (
        <g
          key={background}
          transform="translate(-94.5 -95.5)"
          className={tone === 'theme'
            ? background === 'dark' ? 'hidden dark:block' : 'dark:hidden'
            : undefined}
        >
          <path
            fill={background === 'dark' ? '#FEF405' : '#2E113D'}
            d="M 143 112 H 311.5 A 24 24 0 0 1 328.47 119.03 L 392.8 184 L 302.1 236.36 A 20 20 0 0 0 292.1 253.68 V 328 H 143 A 24 24 0 0 1 119 304 V 269 A 44 44 0 0 0 119 181 V 136 A 24 24 0 0 1 143 112 Z"
          />
          <path
            fill="#B798FD"
            d="M 392.8 184 L 302.1 236.36 A 20 20 0 0 0 292.1 253.68 V 387 A 16 16 0 0 0 315.48 401.2 L 381.07 367.1 A 24 24 0 0 0 394 345.81 V 190 A 16 16 0 0 0 392.8 184 Z"
          />
        </g>
      ))}
    </svg>
  )
}

export function ConnectLogo({ tone, className, markClassName }: {
  tone: ConnectLogoTone
  className?: string
  markClassName?: string
}) {
  return (
    <span className={cn('inline-flex items-center gap-2 font-sans font-semibold not-italic tracking-tight', className)}>
      <ConnectMark tone={tone} className={cn('size-8 shrink-0', markClassName)} />
      <span>{CONNECT_BRAND.name}</span>
    </span>
  )
}
